var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30c7.732 0 14-6.268 14-14 0-.435-.02-.866-.059-1.29-1.149 3.107-4.373 6.793-8.862 9.754-3.827 2.523-7.777 3.992-10.909 4.268A13.948 13.948 0 0 0 16 30zM28.107 8.965C25.68 4.8 21.167 2 16 2 8.268 2 2 8.268 2 16c0 2.788.815 5.386 2.22 7.568.161-.703.444-1.448.839-2.215-.482 1.256-.497 2.387.057 3.226 1.52 2.304 6.744 1.539 11.67-1.71 4.926-3.247 7.688-7.748 6.169-10.052-1.52-2.304-6.745-1.54-11.67 1.708a22.52 22.52 0 0 0-1.917 1.412 31.227 31.227 0 0 1 4.019-3.136C19.033 9.08 24.944 7.65 28.106 8.965zm-19.93 9.643a1.51 1.51 0 1 0 0-3.02 1.51 1.51 0 0 0 0 3.02z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxs);
export default __webpack_public_path__ + "static/media/NXS.73fe9cea3f27f26e71fdb6332d99c0f9.svg";
export { ForwardRef as ReactComponent };